import gql from "graphql-tag";
import { client } from "../src/apollo.js";

const LOGIN_QUERY = gql`
  query ($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      token
      user {
        email
      }
    }
  }
`;

const FORGOT_PASSWORD_MUTATION = gql`
  mutation ($email: String!, $currentLang: String!) {
    forgotPassword(email: $email, currentLang: $currentLang)
  }
`;

export const loginUser = async (email, password) => {
  const result = await client.query({
    query: LOGIN_QUERY,
    variables: { email, password },
  });
  return result;
};

export const forgotPassword = async (email, currentLang) => {
  const result = await client.mutate({
    mutation: FORGOT_PASSWORD_MUTATION,
    variables: { email, currentLang },
  });
  return result;
};
